<div class="toggle-switch" [ngClass]="containerClass + ' toggle-switch-' + size" [tooltip]="tooltip"
  [placement]="placement" role="switch" [attr.aria-checked]="toggled" tabindex="0" (click)="onToggle($event)"
  (keydown)="onKeydown($event)">
  <span *ngIf="label && labelPosition !== 'right'" class="">{{ label }}</span>
  <span class="fas toggle__icon" [ngClass]="toggled ? iconOnClass : iconOffClass"></span>
  <span *ngIf="label && labelPosition === 'right'" class="">{{ label }}</span>
</div>